import React from "react";
import classNames from "classnames";
import { useFormState } from "react-final-form";
import { Popover } from "@blueprintjs/core";
import Button, { ButtonStyle } from "components/Button";
import { isFormChanged } from "shared/validators";
import { DIALOG_ACTION_TITLE } from "shared/labels";
import * as styles from "./styles.module.scss";
const ResultDimensionDialog = ({ title, children, selectedId, onSubmit, submitDisabled, submitTitle = "", classes, placement = "bottom", onClosed, onClose, hasBackdrop = true, }) => {
    const state = useFormState();
    return (React.createElement(Popover, { isOpen: true, onClosed: onClosed, hasBackdrop: hasBackdrop, content: React.createElement("div", { className: classNames(styles.content, classes?.content) },
            React.createElement("h4", { className: styles["content-title"] }, title),
            children,
            React.createElement("div", { className: classNames(styles["content-actions"], classes?.actions) },
                React.createElement(Button, { onClick: onClose, style: ButtonStyle.Tertiary, label: DIALOG_ACTION_TITLE.CANCEL }),
                React.createElement(Button, { onClick: isFormChanged(state, selectedId) ? onSubmit : onClose, disabled: submitDisabled, title: submitTitle, showTooltipIfDisabled: true, style: ButtonStyle.Primary, label: DIALOG_ACTION_TITLE.OK }))), portalClassName: styles.portal, className: classNames(styles.target, classes?.target), placement: placement, minimal: true, backdropProps: { className: styles.backdrop }, modifiers: {
            preventOverflow: {
                enabled: true,
                options: {
                    padding: 10,
                    altAxis: true,
                },
            },
            flip: {
                enabled: false,
            },
        } },
        React.createElement("span", null)));
};
export default ResultDimensionDialog;
